export enum AvailabilityRequestType {
    Get,
    Check,
    Book,
}
